'use strict';

require('octicons/octicons/octicons.css');

module.exports = require('./Octicon');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-octicon/lib/index.js
 ** module id = 199
 ** module chunks = 0
 **/